import { TaskSubtype, TaskType } from "@/models/task-types";
import { TaskSubtypeApiDTO, TaskTypeApiDTO } from "../dtos/task-type.api.dto";

export const mapTaskSubtypeDTO = (taskSubtypeDTO: TaskSubtypeApiDTO): TaskSubtype => {
  return {
    _id: taskSubtypeDTO._id,
    name: taskSubtypeDTO.name,
    translations: taskSubtypeDTO.translations,
  };
};

export const mapTaskTypeDTO = (taskTypeDTO: TaskTypeApiDTO): TaskType => {
  return {
    _id: taskTypeDTO._id,
    name: taskTypeDTO.name,
    translations: taskTypeDTO.translations,
    subtypes: taskTypeDTO.subtypes?.map(mapTaskSubtypeDTO) || [],
  };
};
